// import { useEffect, useState } from 'react';
import Explore from '../components/Explore';

const ExploreView = () => {
    return <Explore />;
};

export default ExploreView;
